import { useState, ReactElement } from 'react';
import { fileUploadMessage } from 'src/components/FileUploadForm/fileUploadMessage/fileUploadMessage';
import ModalImg from 'src/assets/images/create-menu-item-modal.png';
import { StatusBar, SnackbarStatus } from '@weareopenr/component-library';
import { useModalNotification } from 'src/hooks/useModalNotification/useModalNotification';
import { importVenues } from 'src/api/importVenues/importVenues';
import { ModalWrapper } from 'src/components';
import FileUploadForm from 'src/components/FileUploadForm';
import { useVenues } from 'src/hooks/useVenues/useVenues';
import { useUserTracking } from 'src/hooks/useUserTracking/useUserTracking';
import styles from './VenuesModal.module.scss';

export interface VenuesModalProps {
  closeModal: () => void;
  open: boolean;
}

const VenuesModal = ({ closeModal, open }: VenuesModalProps): ReactElement => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { errorMessage, showNotification, clearError } = useModalNotification();
  const { trackEvent, captureException } = useUserTracking();
  const { refetch } = useVenues();

  const handleSubmit = ({ files }: { files: File }) => {
    if (!files) return;

    clearError();
    setIsLoading(true);

    importVenues(files)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }

        return res.text().then((res: string) => {
          const errObject: {
            ['message']: string;
          } = JSON.parse(res);

          throw new Error(errObject.message);
        });
      })
      .then((res) => {
        trackEvent('venues_imported', { added: res?.added, updated: res?.updated });
        showNotification({
          status: SnackbarStatus.SUCCESS,
          message: fileUploadMessage('venue', res),
        });
        refetch();
        closeModal();
      })
      .catch((err: Error) => {
        captureException(err, { tags: { action: 'import_venues' } });
        showNotification({
          status: SnackbarStatus.ERROR,
          message: err?.message || 'Internal Server Error',
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <ModalWrapper closeModal={closeModal} open={open} image={ModalImg} imageAlt="Picture of ingredient">
      <>
        <FileUploadForm
          formTitle="Import venues"
          formMessage="Select CSV for upload"
          fileExtension=".csv"
          isLoading={isLoading}
          onFormSubmit={handleSubmit}
        />
        <div className={styles['error-banner']}>
          {errorMessage && <StatusBar message={errorMessage} variant="error" />}
        </div>
      </>
    </ModalWrapper>
  );
};

export default VenuesModal;
